import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllPhoneAction } from '../../../redux/actions/communicationAction';
import {
  Accordion, AccordionSummary, AccordionDetails, Typography,
  TableContainer, Paper, Table, TableHead, TableRow, TableCell,
  TableBody,
  Box,
  FormControl,
  Select,
  MenuItem,
  Pagination
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Phone = ({ poppinsFont }) => {
  const [phonePage, setPhonePage] = useState(0);
  const [rowsPerPagePhone, setRowsPerPagePhone] = useState(5);
  const [phoneData, setPhoneData] = useState([]);

  const phones = useSelector((state) => state.communication?.allPhones?.content || []);
  const phonesPagination = useSelector((state) => state.communication?.allPhones || { totalElements: 0, page: 0 });

  const dispatch = useDispatch();

const hasFetchedPhone = useRef(false);

// useEffect(() => {
//   if (!hasFetchedPhone.current) {
//     dispatch(getAllPhoneAction(phonePage, rowsPerPagePhone));
//     hasFetchedPhone.current = true;
//   }
// }, [dispatch]);

  useEffect(() => {
    setPhoneData(phones || []);
  }, [phones]);

  const handleChangePagePhone = (event, newPage) => setPhonePage(newPage);

  const handleChangeRowsPerPagePhone = (event) => {
    setRowsPerPagePhone(parseInt(event.target.value, 10));
    setPhonePage(0);
  };

  return (
    <>
      {renderTable(
        phoneData,
        "Phone",
        phonesPagination,
        phonePage,
        rowsPerPagePhone,
        handleChangePagePhone,
        handleChangeRowsPerPagePhone,
        poppinsFont
      )}
    </>
  );
};

export default Phone;

// Render Table Function with Pagination
const renderTable = (data = [], label, pagination, page, rowsPerPage, handlePageChange, handleRowsPerPageChange, poppinsFont) => {
  return (
    <Box sx={{ml:2,mr:2,mb:2,mt:2}}>
    <Accordion defaultExpanded sx={{ mt: 2, backgroundColor: '#f5f5f5' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={poppinsFont}>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {data.length > 0 ? (
          <>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Policy Number</TableCell>
                          <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Type</TableCell>

                    <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Date</TableCell>
                    <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Subject</TableCell>
                    <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Delivered</TableCell>
                    <TableCell className="styled-table-heading" sx={{ fontWeight: 'bold' }}>Response</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((row, index) => (
                    <TableRow className="styled-table-row" key={index}>
                      <TableCell>{row.policyNumber}</TableCell>
                      <TableCell>{row.subject}</TableCell>
                      <TableCell>{row.date}</TableCell>
                      <TableCell>{row.subject}</TableCell>
                      <TableCell>{row.delivered ? 'Yes' : 'No'}</TableCell>
                      <TableCell>{row.response}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination Controls */}
            {pagination.totalElements > 0 && (
  <Box
    display="flex"
    justifyContent="flex-end"
    alignItems="center"
    mt={2}
    px={2}
  >
    {/* Rows per page dropdown */}
    <span style={{ marginRight: 8, fontSize: '14px' }}>Rows per page:</span>
    <FormControl size="small">
      <Select
        value={rowsPerPage}
        onChange={handleRowsPerPageChange}
        displayEmpty
      >
        {[5, 10, 25].map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>

    {/* Pagination buttons */}
    <Pagination
      count={Math.ceil(pagination.totalElements / rowsPerPage)}
      page={page + 1} // MUI's Pagination is 1-based
      onChange={(event, newPage) => handlePageChange(event, newPage - 1)}

    />
  </Box>
)}

          </>
        ) : (
          <Typography align="center" sx={{ mt: 2 }}>
            No Record Found
          </Typography>
        )}
      </AccordionDetails>
    </Accordion>
    </Box>
  );
};
